const TOKEN_KEY = 'communapp_token';
const REFRESH_KEY = 'communapp_refresh_token';
export function getToken() {
    return localStorage.getItem(TOKEN_KEY);
}
export function setToken(token) {
    localStorage.setItem(TOKEN_KEY, token);
}
export function getRefreshToken() {
    return localStorage.getItem(REFRESH_KEY);
}
export function setRefreshToken(token) {
    localStorage.setItem(REFRESH_KEY, token);
}
export function clearTokens() {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(REFRESH_KEY);
}
